import { FunctionalComponent } from 'preact';
import { route } from 'preact-router';
import { useEffect } from 'preact/hooks';

interface IProps {
    to: string;
}

const Breadcrumbs: FunctionalComponent<IProps> = ({ to }) => {
    useEffect(() => {
        route(to, true);
    }, []);

    return null;
};

export default Breadcrumbs;
